/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DeleteGlobalToolVariationResult = {
  /**
   * The ID of the variation that was deleted
   */
  variationId: string;
};

/** @internal */
export const DeleteGlobalToolVariationResult$inboundSchema: z.ZodMiniType<
  DeleteGlobalToolVariationResult,
  unknown
> = z.pipe(
  z.object({
    variation_id: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "variation_id": "variationId",
    });
  }),
);

export function deleteGlobalToolVariationResultFromJSON(
  jsonString: string,
): SafeParseResult<DeleteGlobalToolVariationResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeleteGlobalToolVariationResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeleteGlobalToolVariationResult' from JSON`,
  );
}
